//#region types
import { TranslationKeys } from "translations";
import { InvoiceConstants } from "utils/constants";
//#endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";

function useInvoicePreviewFormHelpers() {
  const serialNumberTemplateValueDisplayText = LocalizationHelperInstance.getFormattedMessage(
    TranslationKeys.Invoice.InvoiceNumberHashTag
  );

  const getFormattedMessage = (template: string, dateDiff: number) => {
    const message = template;
    return message
      .replace(InvoiceConstants.ReminderDueDaysTemplateValue, `${dateDiff}`)
      .replace(
        InvoiceConstants.ReminderDueDateTemplateValue,
        LocalizationHelperInstance.getFormattedDate(DateHelper.addDays(DateHelper.today(), dateDiff))
      );
  };

  return {
    serialNumberTemplateValueDisplayText,
    getFormattedMessage,
  };
}

export default useInvoicePreviewFormHelpers;
